export enum NotificationTypes {
    Normal,
    News,
    Requests,
}